export const DAY_NAMES = ['일', '월', '화', '수', '목', '금', '토'];
export const MONTH_NAMES = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

export function getNewsDate(news) {
  const dt = news.uploadStatus === 'UPLOADED' ? news.uploadedAt : (news.scheduledAt || news.createdAt);
  return dt ? dt.substring(0, 10) : null;
}

export function getNewsTime(news) {
  const dt = news.uploadStatus === 'UPLOADED' ? news.uploadedAt : (news.scheduledAt || news.createdAt);
  if (!dt) return '';
  const time = dt.substring(11, 16);
  return time === '00:00' ? '' : time;
}

export function groupNewsByDate(list) {
  const map = {};
  list.forEach(news => {
    const dateStr = getNewsDate(news);
    if (!dateStr) return;
    if (!map[dateStr]) map[dateStr] = [];
    map[dateStr].push(news);
  });
  return map;
}

export function generateCalendarDays(year, month) {
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const prevMonthDays = new Date(year, month, 0).getDate();
  const days = [];
  for (let i = firstDay - 1; i >= 0; i--) days.push({ day: prevMonthDays - i, isCurrentMonth: false, isPrev: true });
  for (let d = 1; d <= daysInMonth; d++) days.push({ day: d, isCurrentMonth: true });
  const remaining = (7 - (days.length % 7)) % 7;
  for (let d = 1; d <= remaining; d++) days.push({ day: d, isCurrentMonth: false, isPrev: false });
  return days;
}

export function getDateStr(dayObj, currentYear, currentMonth) {
  let y = currentYear, m = currentMonth;
  if (!dayObj.isCurrentMonth) {
    if (dayObj.isPrev) { m = m - 1; if (m < 0) { m = 11; y--; } }
    else { m = m + 1; if (m > 11) { m = 0; y++; } }
  }
  return `${y}-${String(m + 1).padStart(2, '0')}-${String(dayObj.day).padStart(2, '0')}`;
}

export function fmtDate(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getWeekDays(startDate) {
  const days = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(startDate);
    d.setDate(d.getDate() + i);
    days.push(d);
  }
  return days;
}

export function statusBadge(status) {
  switch (status) {
    case 'UPLOADED': return { bg: 'bg-emerald-500/20', text: 'text-emerald-400', border: 'border-emerald-500/30', label: '완료' };
    case 'PENDING': return { bg: 'bg-amber-500/20', text: 'text-amber-400', border: 'border-amber-500/30', label: '대기' };
    case 'FAILED': return { bg: 'bg-red-500/20', text: 'text-red-400', border: 'border-red-500/30', label: '실패' };
    default: return { bg: 'bg-slate-500/20', text: 'text-slate-400', border: 'border-slate-500/30', label: status };
  }
}

export function getTodayStr() {
  const today = new Date();
  return fmtDate(today);
}

export function getDefaultDates() {
  const start = new Date();
  start.setDate(start.getDate() + 1);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  return { startDate: fmtDate(start), endDate: fmtDate(end) };
}
